import React, { useState, useEffect } from 'react';
import './PrivacyPolicy.css';
import Footer from './Footer';
import { Helmet } from 'react-helmet-async';

const Terms = () => {
  const [activeLink, setActiveLink] = useState('');

  // This effect runs once when the component mounts
  useEffect(() => {
    // Get the current path from the URL (e.g., "/privacy-policy")
    const currentPath = window.location.pathname;
    setActiveLink(currentPath);
  }, []); // The empty array ensures this effect runs only once

  return (
    <>
      <Helmet>
        <meta name="title" content="Terms of Service | Get Next Visa - AI Powered Student Visa Report" />
        <title>Terms of Service | Get Next Visa - AI Powered Student Visa Report</title>
        <meta name="description" content="Get personalized, AI-powered visa reports. Discover the best countries and colleges for your study abroad journey." />
      </Helmet>

      <div className="privacy-banner">
        <div className="privacy-container">
          <nav className="privacy-nav">
            <ul>
              {/* Conditionally apply the 'active' class based on the current path */}
              <li><a href="/privacy-policy" className={activeLink === '/privacy-policy' ? 'active' : ''}>PRIVACY POLICY</a></li>
              <li><a href="/terms" className={activeLink === '/terms' ? 'active' : ''}>TERMS OF SERVICE</a></li>
              <li><a href="/refund-policy" className={activeLink === '/refund-policy' ? 'active' : ''}>REFUND POLICY</a></li>
            </ul>
          </nav>
          <main className="privacy-content">
            <header className="privacy-header">
              <h1>Terms of Use of Get Next Visa</h1>
              <p>Last updated: July 16, 2025</p>
              <p><b>By accessing or using <a href="https://getnextvisa.com">https://getnextvisa.com</a> (the “Website”) and our AI‑driven
                educational visa reports (“Services”), you agree to be bound by these Terms of Use
                (“Terms”). If you do not agree, please do not use the Website or Services.</b>
              </p>
            </header>


            <section className="privacy-section">
              <h2>1. Eligibility</h2>
              <ul>
                <li>You must be at least 16 years old to use the Website.</li>
                <li>By using the Website, you represent that you have the legal capacity to enter into these Terms.</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>2. Account Registration & Security</h2>
              <ul>
                <li>You agree to provide accurate, current, and complete information when
                  registering.</li>
                <li>You are responsible for safeguarding your password and account.</li>
                <li>Notify us immediately of any unauthorized use or security breach.</li>
              </ul>
            </section>


            <section className="privacy-section">
              <h2> 3. User Conduct</h2>
              <ul>
                <p>You agree not to:</p>
                <li>Use the Website for unlawful purposes or in violation of applicable laws.
                </li>
                <li>Post or transmit malicious code, spam, or unsolicited advertising.
                </li>
                <li> Interfere with the security or integrity of our networks or Services.
                </li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>4. User Representations & Warranties</h2>
              <p>You represent and warrant that any data, content, or materials you submit to the Website are accurate, lawful, and non‑infringing.</p>
            </section>

            <section className="privacy-section">
              <h2>5. Intellectual Property</h2>
              <ul>

                <li>All content on the Website (text, graphics, logos, software) is owned or
                  licensed by GetNextVisa and protected by copyright, trademark, and other
                  laws
                </li>
                <li>You may view and download material for personal, non‑commercial use only
                </li>
                <li>You must not reproduce, distribute, modify, or create derivative works without
                  our prior written consent.
                </li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>6. Paid Services & Payment Terms</h2>
              <ul>

                <li>All prices are quoted in INR and are exclusive of taxes unless stated otherwise.
                </li>
                <li>Payment is due at time of purchase; you authorize us (via Razorpay) to
                  charge your selected payment method.
                </li>
                <li>As detailed in our Refund Policy, no cash refunds are issued—only coupon
                  credits for eligible errors.
                </li>
              </ul>
            </section>


            <section className="privacy-section">
              <h2>7. Privacy Policies</h2>
              <ul>
                <p>Your use of the Website is also governed by our:</p>
                <li><b>Privacy Policy:</b> <a href="https://getnextvisa.com/privacy-policy">https://getnextvisa.com/privacy-policy</a></li>
                {/* <li><b>Cookie Policy:</b> <a href="https://gnv.indraq.info/cookies">https://gnv.indraq.info/cookies</a></li> */}

              </ul>
            </section>

            <section className="privacy-section">
              <h2>8. Account Suspension & Termination</h2>
              <ul>

                <li>We reserve the right to suspend or terminate your account (and delete all
                  associated data) if you violate these Terms.

                </li>
                <li>Following termination, you are permanently banned from registering new
                  accounts
                </li>

              </ul>
            </section>



            <section className="privacy-section">
              <h2>9. Service Availability & Maintenance</h2>
              <ul>

                <li>We may update, modify, or discontinue features of the Website or Services at
                  any time, with or without notice.

                </li>
                <li>We are not liable for any downtime, interruptions, or unavailability.

                </li>

              </ul>
            </section>

            <section className="privacy-section">
              <h2>10. Disclaimers</h2>
              <ul>

                <li><b>No Professional Advice:</b> Reports are advisory only; always verify independently.</li>
                <li><b>“As Is” Basis:</b> Services and Website are provided “as is” and “as available.” </li>
                <li> We disclaim all warranties, express or implied, to the fullest extent permitted by law. </li>
              </ul>
            </section>




            <section className="privacy-section">
              <h2>11. Limitation of Liability</h2>
              <p>To the maximum extent permitted by law, GetNextVisa and its affiliates will not be
                liable for any indirect, incidental, special, or consequential damages arising out of or
                in connection with your use of the Website or Services.
              </p>
            </section>



            <section className="privacy-section">
              <h2>12. Indemnification</h2>
              <p>You agree to indemnify and hold harmless GetNextVisa, its officers, directors,
                employees, and agents from any claim or demand arising out of your violation of
                these Terms or your use of the Website.
              </p>
            </section>




            <section className="privacy-section">
              <h2>13. Governing Law & Dispute Resolution</h2>
              <ul>
                <li>These Terms are governed by the laws of India, without regard to
                  conflict‑of‑law principles.</li>
                <li>Any dispute must be brought in the courts of [Your City], India</li>
              </ul>
            </section>


            <section className="privacy-section">
              <h2>14. Severability, Waiver & Entire Agreement</h2>
              <ul>
                <li>If any provision of these Terms is found invalid, the remaining provisions will remain in full force.</li>
                <li>Failure to enforce a right is not a waiver of that right</li>
                <li>These Terms (and the linked policies) constitute the entire agreement between you and GetNextVisa regarding the Website and Services.</li>
              </ul>
            </section>


            <section className="privacy-section">
              <h2>15. Force Majeure</h2>
              <p>We are not liable for delays or failures in performance due to events beyond our
                reasonable control, including natural disasters, strikes, or power failures.</p>
            </section>



            <section className="privacy-section">
              <h2>16. Assignment
              </h2>
              <p>We may assign our rights and obligations under these Terms (e.g., in connection
                with a merger). You may not assign your rights without our prior written consent.
              </p>
            </section>



            <section className="privacy-section">
              <h2>17. Notice</h2>
              <p>All official notices under these Terms must be sent via email
                to <a href="https://getnextvisa.com/privacy-policy"> privacy@getnextvisa.com.</a> We may send notices to the email you provide upon
                registration.
              </p>
            </section>



            <section className="privacy-section">
              <h2>18. Third‑Party Services</h2>
              <ul>
                <li>Our Website may include links, embeds, or integrations with third‑party
                  services (e.g., chat widgets, maps, analytics).
                </li>
                <li>Your use of those services is governed by the third parties’ own terms and
                  policies.</li>
              </ul>
            </section>


            <section className="privacy-section">
              <h2>19. Changes to Terms
              </h2>
              <p>We may update these Terms at any time. Material changes will be posted with a new
                “Last updated” date and emailed to registered users.

              </p>
            </section>

            <section className="privacy-section">
              <h2>20. Contact Us  </h2>

              <ul>
                <p>If you have questions about these Terms, please contact us:</p>
                <li>Email: <a href="mailto:privacy@getnextvisa.com">privacy@getnextvisa.com</a></li>
                <li>Support Ticket: <a href="https://getnextvisa.com/Contact">https://getnextvisa.com/Contact</a></li>
              </ul>

            </section>

            <p>Thank you for using GetNextVisa. We’re committed to providing you with reliable,
              user‑friendly services and transparent policies.</p>

          </main>
        </div>

      </div>

      <Footer />
    </>
  );
};

export default Terms;